<p-card>
  <article class="flex flex-col">
    <h1 class="font-app-bold text-black text-lg">{{ header }}</h1>
    <section class="flex flex-col md:flex-row md:items-center">
      <p
        #htmlDescription
        class="text-dark md:text-justify md:flex-[1_1_auto] mt-4"
        [innerHTML]="description"></p>
      <button
        pButton
        [label]="'offers.createQuotationButton' | translate"
        [text]="true"
        class="bg-primary text-white md:flex-[0_0_auto] justify-center md:w-64 font-bold px-4 py-2 md:ml-16 mt-4"
        (click)="createQuotationClick()"></button>
    </section>
    <a
      *ngIf="aboutLink"
      [href]="aboutLink"
      target="_blank"
      rel="noopener noreferrer"
      class="p-button inline-block self-stretch md:self-start bg-transparent text-primary justify-center font-bold md:-ml-5 mt-2">
      {{ "offers.aboutButton" | translate }}
    </a>
    <button
      pButton
      *ngIf="showResourcesLimitsButton"
      [label]="'offers.resourcesLimitsButton' | translate"
      [text]="true"
      class="inline-block self-center md:self-start text-primary font-bold mt-2"
      (onClick)="showResourcesLimitsButtonClick()"></button>
  </article>
</p-card>

